import React, { useEffect, useRef, useState } from 'react';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import FileService from '../service/FileService';
import Constants from '../constants/Constants';
import { useNavigate } from 'react-router-dom';

const MuseumCarousel2 = (props) => {
    const navigate = useNavigate();


    const [itemWidth, setItemWidth] = useState(525);
    const itemHeight = 410;

    const ref = useRef(null);
    const [showCount, setShowCount] = useState(null);

    const responsive = {
        0: { 
            items: 1,
            itemsFit: 'contain'
        },
        480: {
            items: 1,
            itemsFit: 'contain'
        },
        768: { 
            items: 2,
            itemsFit: 'contain'
        },
        1024: { 
            items: 3,
            itemsFit: 'contain'
        },
        1200: {
            items: 4,
            itemsFit: 'contain',
            autoWidth: true
        }
    };


    useEffect(() => {
        function handleResize() {
            let _itemWidth = itemWidth;
            if (ref.current.offsetWidth < itemWidth) {
                _itemWidth = ref.current.offsetWidth;
                setItemWidth(_itemWidth);
            }
            let _show = ref.current.offsetWidth / _itemWidth;
            console.log("getShow size width", ref.current.offsetWidth, _itemWidth, _show);
            setShowCount(_show);
        }
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const onSelectedMuseum = (param) => {
        console.log("onSelectedExhibit", param)
        navigate("/profile/" + param.id + "/" + Constants.userType.company);
    }


    const carouselItemTemplate = (exhibition) => {
        return (
            <div className='pointer'
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    margin: 10,
                    borderRadius: 20,
                    backgroundImage: `url(${FileService.inquireFilePath(exhibition.profileHeader)})`,

                    minHeight: 400,
                    backgroundSize: 'cover',
                    backgroundPositionX: 'center',
                    backgroundPositionY: 'center',
                    backgroundRepeat: 'no-repeat',


                }}
                onClick={() => onSelectedMuseum(exhibition)}
            >
                <div style={{
                    width: '100%'

                }}>

                    <div style={{

                        flexDirection: 'column', // inner items will be added vertically
                        flexGrow: 1,            // all the available vertical space will be occupied by it
                        justifyContent: 'space-between', // will create the gutter between body and footer
                        height: '100%',
                        display: 'flex',
                        background: 'linear-gradient(rgb(0,0,0,0), rgb(0, 0,0,0.7))',
                        borderRadius: 20,
                        padding: 10,

                    }}>
                        <div style={{

                            color: '#ffffff',
                            textAlign: 'center',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            flexDirection: 'column', // inner items will be added vertically
                            flexGrow: 1,            // all the available vertical space will be occupied by it


                        }}>
                            <div style={{
                                height: '40%',

                                justifyContent: 'center',
                                display: 'flex',
                                alignItems: 'center',
                                flexDirection: 'column', // inner items will be added vertically

                            }}>
                                {exhibition.owner &&
                                    <div style={{
                                        fontSize: 16,
                                        color: '#ffffff',
                                        padding: 10,

                                        textAlign: 'center',

                                    }} >
                                        {exhibition.owner}
                                    </div>
                                }
                                <div className="question" style={{
                                    fontSize: 30,
                                    color: '#ffffff',
                                    padding: 10,

                                    textAlign: 'center',

                                }} >
                                    {exhibition.companyName}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    };


    const getItems = () => {

        let _items = [];
        props.data.map((param, index) => {
            _items.push(
                <div key={index} style={{ width: itemWidth, height: itemHeight }}>
                    {carouselItemTemplate(param, (param.length - 1) == index)}

                </div>
            )
        })
        return _items;

    }

    const renderCarosel = () => {
        if (!showCount) {
            return <></>
        }


        return (
            <AliceCarousel 
                mouseTracking 
                items={getItems()} 
                responsive={responsive}
                disableDotsControls
                disableButtonsControls
                autoWidth
                autoHeight
                controlsStrategy="alternate"
            />
        );
    }
    return (
        <div ref={ref}>
            {renderCarosel()}
        </div>
    );
};

export default MuseumCarousel2;
